import React, { FC, ReactNode, SyntheticEvent } from 'react'
import { BankrateDisplayOffer } from 'utils/offers'

import { useStoreState, useStoreActions } from 'store'
import { useTrackingLink } from 'hooks/useTrackingLink'
import { setPreFillCookie } from 'utils/setPreFillCookie'
import generateUniqueId from 'utils/generateUniqueId'

import querystring from 'query-string'
import { offerClickDdTags } from 'utils/offers'

interface Props {
  offer: BankrateDisplayOffer
  rowPosition: number
  clickType: 8 | 11
  className?: string
  children?: ReactNode
  text?: string
  testId?: string
}

const CTAButton: FC<Props> = ({
  offer,
  rowPosition,
  clickType,
  className = '',
  text = '',
  testId = 'row-cta-button',
  ...props
}) => {
  const { generateLink } = useTrackingLink()
  const dimensions = useStoreState(state => state.dimensions.dimensions)
  const downPaymentPercentage = useStoreState(state => state.dimensions.downPaymentPercentage)

  const { onProductTracking, onClickTracking } = useStoreActions(actions => actions.tracking)
  const increment = useStoreActions(actions => actions.datadog.increment)
  const flags = useStoreState(state => state.featureFlags.flags)

  const e2eTestEnabled = querystring.parse(window.location.search).e2eTestEnabled === 'true'
  const purchaseId = generateUniqueId()

  const clickHandler = (event: SyntheticEvent) => {
    event.preventDefault()
    event.stopPropagation()
    setPreFillCookie(dimensions, downPaymentPercentage)

    let tags = offerClickDdTags(offer, rowPosition)
    increment({ name: 'offers.clicks', value: 1, tags })

    const trackingLink = generateLink(offer, rowPosition, clickType, flags['CTAText'], purchaseId)

    onProductTracking({ eventName: 'ProductClicked', offer, position: rowPosition, id: purchaseId, text })

    // the sage sponsored ad set id
    if (String(offer.adSetId) === '35253') {
      const clickText = clickType === 8 ? 'Logo' : 'Next'
      onClickTracking({
        element: {
          type: 'banner',
          text: clickText,
          position: 'middle',
          location: 'rate table',
          name: 'Sage sponsored cash out refi tile',
        },
        outcome: 'INTERNALLINK',
      })
    }

    if (flags.elf && trackingLink.includes('iscpl=true')) {
      window.postMessage(
        {
          triggerId: 'rate_table_row_click',
          name: 'SHOW_EMBEDDED_FORM',
          formUrl: trackingLink,
        },
        '*'
      )
    } else {
      window.open(trackingLink, '_blank')
    }
  }

  return (
    // eslint-disable-next-line
    <a
      data-testid={testId}
      onClick={clickHandler}
      style={{ whiteSpace: 'nowrap' }}
      className={className}
      target="_blank"
      rel="noopener noreferrer"
      // This is this way to enable the e2e tests in NR to work properly.
      // Also to prevent prefetching of links, as we especially don't want
      // that to occur for tracking links.
      href={e2eTestEnabled ? offer.tracking?.link : ''}
    >
      {props.children ? (
        props.children
      ) : (
        <>
          {flags['CTAText'] as string}
          <svg
            className="Icon Icon--xs mb-1 ml-2"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 12L13.8863 18L12.3579 16.5L15.7204 13.2H3V10.8H15.7204L12.3579 7.5L13.8863 6L20 12Z"
              fill="#FFF"
            />
          </svg>
        </>
      )}
    </a>
  )
}

export default CTAButton
